import React from 'react';
import { Check, Star, TrendingUp } from 'lucide-react';

const Services = () => {
  const services = [
    {
      badge: 'MAIS POPULAR',
      name: 'Site Institucional',
      price: 'R$ 3.451',
      description: 'Presença digital profissional que estabelece autoridade e credibilidade no mercado.',
      features: [
        'Design exclusivo e responsivo',
        'Até 8 páginas profissionais',
        'SEO otimizado para Google',
        'Formulário de contato integrado',
        'Integração redes sociais',
        'Painel administrativo',
        'Certificado SSL incluso',
        '2 revisões incluídas'
      ],
      icon: <Star size={32} />
    },
    {
      badge: 'ALTO ROI',
      name: 'Página de Vendas',
      price: 'R$ 993',
      description: 'Landing page otimizada para converter visitantes em clientes pagantes.',
      features: [
        'Copywriting persuasivo',
        'Design focado em conversão',
        'Botões de ação estratégicos',
        'Integração com WhatsApp',
        'Depoimentos e provas sociais',
        'Contagem regressiva (urgência)',
        'Responsivo para mobile',
        '1 revisão incluída'
      ],
      icon: <TrendingUp size={32} />
    }
  ];

  return (
    <section id="servicos" style={{
      padding: '120px 40px',
      background: 'linear-gradient(180deg, #000000 0%, #0a0a0a 100%)'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div className="fade-in" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title">
            Soluções que <span className="gold-gradient">Transformam</span> Negócios
          </h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Cada projeto é desenvolvido com tecnologia de ponta e estratégia de vendas comprovada.
            Escolha a solução ideal para o seu momento.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '40px',
          marginBottom: '60px'
        }}>
          {services.map((service, idx) => (
            <div
              key={idx}
              className="fade-in"
              style={{
                background: 'linear-gradient(145deg, rgba(10, 10, 10, 0.8) 0%, rgba(0, 0, 0, 0.9) 100%)',
                border: '2px solid rgba(212, 175, 55, 0.3)',
                borderRadius: '16px',
                padding: '50px',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                transitionDelay: `${idx * 0.2}s`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 30px 60px rgba(212, 175, 55, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Badge */}
              <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'linear-gradient(135deg, #D4AF37 0%, #F4E5C3 100%)',
                color: '#000000',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '700',
                letterSpacing: '1px'
              }}>
                {service.badge}
              </div>

              {/* Icon */}
              <div style={{ color: '#D4AF37', marginBottom: '20px' }}>
                {service.icon}
              </div>

              {/* Service name */}
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '32px',
                fontWeight: '700',
                marginBottom: '10px',
                color: '#FFFFFF'
              }}>
                {service.name}
              </h3>

              {/* Price */}
              <div style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '48px',
                fontWeight: '700',
                color: '#D4AF37',
                marginBottom: '20px'
              }}>
                {service.price}
                <span style={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: '#CCCCCC',
                  marginLeft: '10px'
                }}>
                  pagamento único
                </span>
              </div>

              {/* Description */}
              <p style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '16px',
                fontWeight: '300',
                color: '#CCCCCC',
                marginBottom: '30px',
                lineHeight: '1.8'
              }}>
                {service.description}
              </p>

              {/* Features */}
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: '0 0 40px 0'
              }}>
                {service.features.map((feature, fIdx) => (
                  <li
                    key={fIdx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      marginBottom: '15px',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '14px',
                      color: '#FFFFFF'
                    }}
                  >
                    <Check size={18} color="#D4AF37" />
                    {feature}
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <button
                onClick={() => window.open(`https://wa.me/5562995664918?text=Olá! Tenho interesse no serviço: ${service.name}`, '_blank')}
                className="btn-primary"
                style={{ width: '100%', fontSize: '16px' }}
              >
                SOLICITAR ORÇAMENTO
              </button>
            </div>
          ))}
        </div>

        {/* Maintenance package */}
        <div className="fade-in" style={{
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, transparent 100%)',
          border: '2px solid rgba(212, 175, 55, 0.4)',
          borderRadius: '16px',
          padding: '50px',
          textAlign: 'center',
          transitionDelay: '0.4s'
        }}>
          <h3 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '32px',
            fontWeight: '700',
            marginBottom: '20px',
            color: '#FFFFFF'
          }}>
            Pacote de <span className="gold-gradient">Manutenção Premium</span>
          </h3>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '18px',
            fontWeight: '300',
            color: '#CCCCCC',
            marginBottom: '30px',
            maxWidth: '800px',
            margin: '0 auto 30px'
          }}>
            Seu site sempre no ar, sempre rápido, sempre seguro. Hospedagem premium + manutenção preventiva + suporte técnico especializado.
          </p>
          <div style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '56px',
            fontWeight: '700',
            color: '#D4AF37',
            marginBottom: '10px'
          }}>
            R$ 69,90<span style={{ fontSize: '24px', fontWeight: '400' }}>/mês</span>
          </div>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '14px',
            fontWeight: '400',
            color: '#CCCCCC',
            marginBottom: '40px'
          }}>
            Hospedagem + Manutenção Preventiva + Suporte Técnico
          </p>
          <button
            onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Gostaria de saber mais sobre o Pacote de Manutenção Premium.', '_blank')}
            className="btn-secondary"
            style={{ fontSize: '16px' }}
          >
            SABER MAIS
          </button>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #servicos > div > div:nth-child(2) {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Services;